var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission('DeveloperTools'))?_c('div',{staticClass:"dev-toggle"},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.devState.active},on:{"change":function($event){return _vm.setDevModeActive()}}}),_c('span',[_vm._v("DEV")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dd558be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/DevToggle.vue
// module id = null
// module chunks = 